/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { PATH_URL } from 'src/helpers'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../../contextAPI'
import { QuizType } from 'src/pages/shared'
import { ENV } from 'src/config/env'
import { SESSION_NAME_LOCAL, useAppContext } from 'src/helpers/app'
import { SegmentAction, segmentTracking } from 'src/helpers/segment'

export const useLinkYourBoard = () => {
  const history = useHistory()
  const { setQuizScreen } = useContext(QuizQuestionContext)
  const { sessionID } = useAppContext()
  const pinterestOauthURL = `https://www.pinterest.com/oauth?redirect_uri=${window.location.origin}/pinterest-boards&response_type=code&scope=boards:read,boards:read_secret,pins:read,pins:read_secret,user_accounts:read&client_id=${ENV.PINTEREST_CLIENT_ID}`

  const handleNext = async () => {
    history.push({
      pathname: PATH_URL.NEW_COLOR_PALETTE_PAGE,
      search: new URLSearchParams({ quizType: QuizType.PINTEREST }).toString(),
    })
    setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_COLOR_PALETTE_PAGE)
  }

  const handleBack = () => {
    if (window.history.length > 1) {
      history.goBack()
    } else {
      history.push({
        pathname: PATH_URL.NEW_BUDGET_PAGE,
        search: new URLSearchParams({ quizType: QuizType.PINTEREST }).toString(),
      })
      setQuizScreen(SCREEN_QUIZ_QUESTION.NEW_BUDGET_PAGE)
    }
  }

  const handlePinterestOauth = () => {
    // Store current session ID in localStorage before redirecting
    console.log('[Pinterest OAuth] Saving session ID before redirect:', sessionID)
    if (sessionID) {
      localStorage.setItem(SESSION_NAME_LOCAL, sessionID)
    }
    // Track Pinterest OAuth click event
    segmentTracking(
      SegmentAction.SQ_PINTEREST_OAUTH_STARTED,
      {
        experienceType: 'pinterest',
      },
      () => {
        window.location.href = pinterestOauthURL
      }
    )
  }

  return {
    handleNext,
    handleBack,
    handlePinterestOauth,
  }
}
